import { UiElement } from '../../ui/UiElement.js';

export { ProjectionSwitcher };

/**
 * Dropdown button to switch the mpa projection
 *
 * @author rhess <robin.hess@awi.de>
 * 
 * @memberof vef.map
 */
class ProjectionSwitcher extends UiElement {

    constructor(map, position, baseLayers) {
        super();

        this.map = map;
        this.position = position || "top-left";
        this.baseLayers = baseLayers;

        this.initElement_();
        this.initEvents_();

        this.map.on("projection_change", () => this.update());
        this.map.on("baselayer_change", () => this.update());
        this.map.addTool(this, this.position);

        this.update();
    }

    initElement_() {
        const element = this.getElement();
        element.classList.add("vef-tool", "tool-dropdown");
        element.innerHTML = `
            <i class="fas fa-globe-europe"></i>
            <div class="tool-dropdown-content">
                <button data-crs="EPSG:4326" title="Global">
                    <i class="vef vef-globe"></i>Global
                </button>
                <button data-crs="EPSG:3995" title="Arctic">
                    <i class="vef vef-globe-north"></i>Arctic
                </button>
                <button data-crs="EPSG:3031" title="Antarctic">
                    <i class="vef vef-globe-south"></i>Antarctic
                </button>
            </div>
        `;
        element.title = "Projection Switcher";
    }

    initEvents_() {
        const element = this.getElement();

        const buttons = element.querySelectorAll(".tool-dropdown-content button");
        for (let i = 0; i < buttons.length; ++i) {
            buttons[i].addEventListener("click", e => {
                const key = this.map.options.baseLayer;
                const crs = e.currentTarget.dataset.crs;
                if (crs in this.baseLayers[key]) {
                    this.map.setBaseLayer(this.baseLayers[key][crs], crs);
                }
            });
        }
    }

    update() {
        const element = this.getElement();

        const key = this.map.options.baseLayer;
        const crs = this.map.options.crs;

        const buttons = element.querySelectorAll(".tool-dropdown-content button");
        for (let i = 0; i < buttons.length; ++i) {
            if ((buttons[i].dataset.crs == crs) || !(buttons[i].dataset.crs in this.baseLayers[key])) {
                buttons[i].disabled = true;
            } else {
                buttons[i].disabled = false;
            }
        }

    }

}